module.exports = __webpack_public_path__ + "static/media/Employee3.f7bd989d.svg";